/* @flow */

const getPrimeiroNome = (nome: string) => nome.split(' ')[0];

export default getPrimeiroNome;
